import { CommonModule } from '@angular/common';
import { DatiqAutocompleteComponent } from './components/datiq-autocomplete/datiq-autocomplete.component';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DatiqAutocompleteOptionNewComponent } from './components/datiq-autocomplete-option-new/datiq-autocomplete-option-new.component';
import { MatButtonModule } from '@angular/material/button';

const components = [DatiqAutocompleteComponent];

@NgModule({
    exports: [...components, DatiqAutocompleteOptionNewComponent],
    declarations: [...components, DatiqAutocompleteOptionNewComponent],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatChipsModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatButtonModule,
        DatiqIconsModule,
    ],
})
export class DatiqAutocompleteModule {}
